import { Injectable, EventEmitter, Output } from '@angular/core';

declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root'
})
export class VoiceRecognitionService {

  @Output() speechResult = new EventEmitter<any>();
  private recognition: any;
 

  constructor() {
    this.initializeRecognition();
  }

  private initializeRecognition() {
    if ('webkitSpeechRecognition' in window) {
      this.recognition = new webkitSpeechRecognition();
      this.recognition.continuous = false;
      this.recognition.interimResults = false;
      this.recognition.lang = 'en-US';

      this.recognition.onresult = this.handleRecognitionResult.bind(this);
      this.recognition.onerror = this.handleRecognitionError.bind(this);
    } else {
      console.warn('Your browser does not support voice recognition!');
    }
  }

  private handleRecognitionResult(event: any) {
    try {
      let results = event.results[0][0].transcript + ' ';
      this.speechResult.emit(results);
    } catch (error) {
      console.error('Error processing recognition result:', error);
    } finally {
      this.stopListening();
    }
  }

  private handleRecognitionError(event: any) {
    console.log('Speech recognition error:', event);
    this.speechResult.emit(null);
    this.stopListening();
  }

  startListening() {
    if (this.recognition) {
      try {
        this.recognition.start();
      } catch (error) {
        console.error('Error starting speech recognition:', error);
      }
    } else {
      console.warn('Speech recognition is not initialized.');
    }
  }

  stopListening() {
    if (this.recognition) {
      try {
        this.recognition.stop();
      } catch (error) {
        console.error('Error stopping speech recognition:', error);
      }
    }
  }

  insertTextAtCursor(text: string, inputField: any) {
    try {
      const cursorPosition = inputField.nativeElement.selectionStart;
      const input = inputField.nativeElement;
      const value = input.value;

      const before = value.substring(0, cursorPosition);
      const after = value.substring(cursorPosition, value.length);

      input.value = `${before}${text}${after}`;
      input.selectionStart = cursorPosition + text.length;
      input.selectionEnd = cursorPosition + text.length;
    } catch (error) {
      console.error('Error inserting text at cursor:', error);
    }
  }
}
